import React, { useEffect } from 'react'
import { Downgraded, useHookstate } from '@hookstate/core'
import { getStatisticsDispatchByCategoryOperationService } from '~/features/Dispatch/services'
import PieChart from '~/components/PieChart'
import PieChartMui from '~/components/PieChartMui'
import ColumnChartVertical from '~/components/ColumnChartMui/VerticalChart'
import { calculateBarChartTotal } from '~/utils/format'

export default function DispatchByCategoryOperationPieChart({
  operationId,
  initialDate,
  endDate,
  refresh,
  loading,
}) {
  const data = useHookstate([])


  useEffect(() => {
    loading.set(true)
    getStatisticsDispatchByCategoryOperationService({
      operationId: operationId,
      initialDate: initialDate,
      endDate: endDate,
    })
      .then((response) => {
        const result = response.map((responseData) => ({
          item: responseData.name,
          value: responseData.total,
        }))
        return data.set(result)
      })
      .finally(() => {
        loading.set(false)
      })
  }, [refresh])

  return (
    // <PieChart data={data.attach(Downgraded).get()} title={'Graph of Occurrences by Category'} sxFont={{ fontWeight: 'bold', fontSize: 16 }} />
    <ColumnChartVertical
      data={data.attach(Downgraded).get()}
      title={'Graph of Occurrences by Category'}
      colorBar="secondary"
      subtitle={`Total de ocorrência: ${calculateBarChartTotal(
        data.attach(Downgraded).get()
      )}`}
      typeTotal={'Categories'}
    />
  )
}
